import React from "react"
import { AuthProvider } from "../contexts/AuthContext"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import "../css/app.css"
import PrivateRoute from "./PrivateRoute"
import Dashboard from "../pages/Dashboard"
import MngBookings from "../pages/MngBookings"
import MngUsers from "../pages/MngUsers"
import VerifyUsers from "../pages/VerifyUsers"
import Profile from "../pages/Profile"
import Login from "../pages/Login"
import ChangePassword from "./ChangePassword"
import ProgressBar from "./ProgressBar"
import TermsAndPolicy from "./TermsAndPolicy"
import TermsAndConditions from "../pages/TermsAndConditions"
import PrivacyPolicy from "../pages/PrivacyPolicy"

function App() {
  return (
    <div>
      <Router>
        <AuthProvider>
          <Routes>

            <Route path='/' element={
              <PrivateRoute>
                <ProgressBar />
              </PrivateRoute>
            } />

            <Route path='/dashboard' element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />

            <Route path='/mngbookings' element={
              <PrivateRoute>
                <MngBookings />
              </PrivateRoute>
            } />

            <Route path='/mngusers' element={
              <PrivateRoute>
                <MngUsers />
              </PrivateRoute>
            } />

            <Route path='/verifyusers' element={
              <PrivateRoute>
                <VerifyUsers />
              </PrivateRoute>
            } />

            <Route path='/profile' element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            } />

            <Route path='/login' element={<Login />} />

            <Route path='/changepass' element={<ChangePassword />} />

            <Route path='/termspolicy' element={<TermsAndPolicy />} />

            <Route path='/termscondition' element={<TermsAndConditions />} />
            <Route path='/privacypolicy' element={<PrivacyPolicy />} />

          </Routes>
        </AuthProvider>
      </Router>
    </div>

  )
}

export default App